import { useEffect } from 'react'
import { usePaymentContext } from '../context'
// import { BUILD_ENV } from '../helpers'
import { HUBSPOT_IFRAME_ID, NODE_ENV } from '../helpers'

export function useHubspotChat() {
  const { is_trial } = usePaymentContext()

  useEffect(() => {
    if (NODE_ENV === 'development') return

    const displayHubspotChat = () => {
      const hubspotChat = document.getElementById(HUBSPOT_IFRAME_ID)

      if (hubspotChat) {
        hubspotChat.style.display = 'block'
        hubspotChat.style.visibility = 'visible'
      }
    }

    // the element is invisible as soon as it appears in the dom
    // handled by the hook use-tracking-scripts.js
    setTimeout(() => {
      if (is_trial) {
        // displayHubspotChat()
      }
    }, 2 * 1000)
  }, [is_trial])
}
